import { createStore, combineReducers, applyMiddleware } from 'redux'
import  createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from 'redux-devtools-extension'
import { saveContactDataWatcherSaga } from 'sagas/contact'
import { reducer as ToastrReducer } from 'react-redux-toastr'

import visibilityReducer from 'reducers/visibility.js'

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

const store = createStore(
    combineReducers({
        visibility: visibilityReducer,
        toastr: ToastrReducer,
    }),
    composeWithDevTools(applyMiddleware(sagaMiddleware))
);

sagaMiddleware.run(saveContactDataWatcherSaga)

export default store;